import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Modal from "react-modal";

const GoodsProductwiseIssuedReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/operationalwise");
  };

  const [isPrinting, setIsPrinting] = useState(false);
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);

  const [printData, setPrintData] = useState([]);

  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseData, setWarehouseData] = useState([]);

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const fillData = (employeeId, warehouseId) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveEmpId=${employeeId}`;
    }

    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.Fdate.value).format("DD/MM/YYYY")}`;
    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.Tdate.value).format("DD/MM/YYYY")}`;

    var url = `/api/fieldExecutiveProductIssue/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillData(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        //   console.log("emp", data);
        setEmployeeData(data);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getwarehouse } = useHttp();
  useEffect(() => {
    getwarehouse(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setWarehouseData(data);
        console.log(data);
      }
    );
  }, [getwarehouse]);

  const fieldsToExport = [
    "goodsTransferDate",
    "goodsTrasnferNo",
    "issuedByEmployeeName",
    "warehouseName",
    "issuedToEmployeeName",
    "productTypeName",
    "productSubTypeName",
    "productName",
    "itemId",
    "itemQuantity",
    "unitAbbreviation",
    "productCost",
  ];

  const customHeaders = [
    "Goods Transfer Date",
    "Goods Transfer No",
    "Isssued By",
    "Warehouse Name",
    "Field Officer Name",
    "Product Type Name ",
    "Product Sub Type Name ",
    "Product Name ",
    "Item Id ",
    "Quantity",
    "Unit",
    "Amount",
  ];

  const handleExportExcel = () => {
    const filename = "FieldOfficerGoodsTransfer(Productwise).xlsx";
    //console.log(fieldsToExport,customHeaders);
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const modalRef = useRef(null);

  const openModal = () => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveEmpId=${employeeId}`;
    }

    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.Fdate.value).format("DD/MM/YYYY")}`;
    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.Tdate.value).format("DD/MM/YYYY")}`;

    var url = `/api/goodsIssueFieldExecutiveDetail/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (res) => {
        console.log(res);
        setPrintData(res);
      }
    );

    setModalIsOpen(true);
  };

  // const handlePrint = () => {
  //   const input = modalRef.current;
  //   html2canvas(input, { scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const margin = 10;
  //     const imgWidth = 210 - 2 * margin; // A4 width (210mm) minus left & right margins
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
  //     pdf.save("GoodsIssueToFieldExecutive.pdf");
  //   });
  // };

  const handlePrint = () => {
    setIsPrinting(true);

    const input = modalRef.current; // The modal content

    const pdf = new jsPDF("p", "mm", "a4");

    const margin = 10; // Margin from all sides
    const imgWidth = 210 - 2 * margin; // A4 width minus margins
    const pageHeight = 297 - 2 * margin; // A4 height minus margins
    let yPosition = margin; // Initial Y position for the first page

    const tableElements = input.querySelectorAll(".print-section");

    const captureAndPrintElement = (element, callback) => {
      html2canvas(element, {
        scale: 2,
        ignoreElements: (element) => element.classList.contains("no-print"),
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (yPosition + imgHeight > pageHeight) {
          pdf.addPage();
          yPosition = margin;
        }

        pdf.addImage(imgData, "PNG", margin, yPosition, imgWidth, imgHeight);
        yPosition += imgHeight + 5;
        callback();
      });
    };

    const processElements = (index) => {
      if (index < tableElements.length) {
        captureAndPrintElement(tableElements[index], () => {
          processElements(index + 1);
        });
      } else {
        pdf.save("GoodsIssueToFieldExecutive.pdf");
        setIsPrinting(false);
      }
    };

    processElements(0);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "450px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        style={modalStyles}
        contentLabel="Goods Issue to Field Executive "
      >
        <div className="">
          <h5 className="card-title">Goods Issue to Field Executive </h5>
          <div className="card-tools text-right no-print">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setModalIsOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3 no-print">
          <button
            className="btn btn-success"
            onClick={handlePrint}
            disabled={isPrinting}
          >
            {isPrinting ? (
              <span>
                <i className="fas fa-spinner fa-spin"></i> Generating PDF...
              </span>
            ) : (
              "Print"
            )}
          </button>
        </div>
        <div ref={modalRef} className="mt-3 mb-0">
          {printData.map((transfer) => (
            <div
              key={transfer.goodsTransferId}
              className="mb-4 border p-3 print-section"
            >
              <div className="d-flex justify-content-between">
                <p>
                  <strong>Field Executive Name:</strong>{" "}
                  {transfer.executiveName}
                </p>
                <p>
                  <strong>Doc No:</strong> {transfer.goodsTrasnferNo}
                </p>
                <p>
                  <strong>Date:</strong>{" "}
                  {new Date(transfer.goodsTransferDate).toLocaleDateString(
                    "en-GB"
                  )}
                </p>
              </div>
              <table className="table table-bordered text-center m-0">
                <thead>
                  <tr className="tabl">
                    <th>Product Name</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {transfer.productData.length > 0 ? (
                    transfer.productData.map((product) => (
                      <tr key={product.goodsTransferProductId}>
                        <td>{product.productName}</td>
                        <td>{product.itemQuantity}</td>
                        <td>{product.unitAbbreviation}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No products available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Officer Goods Transfer-Productwise
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Warehouse Name</label>
                  <select
                    id="warehouseId"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouseId"] = el)}
                    value={warehouseId}
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {warehouseData &&
                      warehouseData.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.empId} value={x.empId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Fdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Tdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillData(employeeId, warehouseId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              {" "}
              <button
                className="btn btn-sm btn-success"
                onClick={() => openModal()}
              >
                <i className="fas fa-print"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-responsive">
                      <thead>
                        <tr className="table-header">
                          <th>Goods Transfer Date</th>
                          <th>Goods Transfer No</th>
                          <th>Isssued By</th>
                          <th> Warehouse Name</th>
                          <th> Field Officer Name</th>
                          <th> Product Type Name </th>
                          <th> Product Sub Type Name </th>
                          <th> Product Name </th>
                          <th>Item Id </th>
                          <th> Quantity</th>
                          <th> Unit</th>

                          <th> Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.goodsTransferDate}</td>
                                <td>{itm.goodsTrasnferNo}</td>
                                <td>{itm.issuedByEmployeeName}</td>
                                <td>{itm.warehouseName}</td>

                                <td>{itm.issuedToEmployeeName}</td>
                                <td>{itm.productTypeName}</td>
                                <td>{itm.productSubTypeName}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.itemId}</td>
                                <td>{itm.itemQuantity}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>
                                  {parseFloat(itm.productCost).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GoodsProductwiseIssuedReport;
